import { TextFieldProps } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { PickersActionBar } from '@mui/x-date-pickers/PickersActionBar';

export type ClearableDatePickerProps<TInputDate extends Date> = Omit<DatePickerProps<TInputDate>, 'renderInput'> & {
    clearable?: boolean;
    dateFormat?: string;
    onClear?: () => void;
    error?: string | false;
    InputProps?: Partial<TextFieldProps>;
};

export const ClearableDatePicker = <TInputDate extends Date = Date>({
    clearable,
    error,
    dateFormat = 'MMM dd, yyyy',
    onClear,
    InputProps,
    ...rest
}: ClearableDatePickerProps<TInputDate>) => {
    return (
        <DatePicker<TInputDate>
            format={dateFormat}
            slotProps={{
                actionBar: {
                    actions: clearable ? ['clear'] : undefined,
                },
                textField: {
                    error: !!error,
                    helperText: error,
                    variant: 'outlined',
                    fullWidth: true,
                    ...InputProps,
                },
            }}
            slots={{
                // FIXME: need to override default action bar because there is no way to use `onClear` callback
                actionBar: (props) => {
                    return (
                        <PickersActionBar
                            {...props}
                            onClear={() => {
                                props.onClear();
                                onClear?.();
                            }}
                        />
                    );
                },
            }}
            {...rest}
        />
    );
};
